import { render } from "./MyLeaves.vue?vue&type=template&id=2a61cef8&scoped=true"
import script from "./MyLeaves.vue?vue&type=script&lang=js"
export * from "./MyLeaves.vue?vue&type=script&lang=js"

import "./MyLeaves.vue?vue&type=style&index=0&id=2a61cef8&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a61cef8"]])

export default __exports__